import { CSSProperties } from "react";

/**
 * Pill de puntos tal como la muestra la app ("+10 puntos"). Ganar puntos va en success y
 * la penalidad (no_show) en error: paleta semántica del §3.2, nunca el verde de marca.
 */
export const pointsTone = (isPenalty: boolean) =>
  isPenalty
    ? { bg: "var(--error-bg-light)", fg: "var(--error-bg-dark)" }
    : { bg: "var(--success-bg-light)", fg: "var(--success-bg-dark)" };

interface PointsBadgeProps {
  /** Texto ya formateado, ej. "+10 puntos". */
  label: string;
  isPenalty?: boolean;
  /** Para ubicarlo en el layout del padre (márgenes); el aspecto del pill no se pisa. */
  style?: CSSProperties;
}

export const PointsBadge = ({ label, isPenalty = false, style }: PointsBadgeProps) => {
  const tone = pointsTone(isPenalty);

  return (
    <span
      className="inline-flex align-items-center align-self-start"
      style={{
        ...style,
        padding: "4px 10px",
        gap: "6px",
        borderRadius: "999px",
        backgroundColor: tone.bg,
        color: tone.fg,
        fontSize: "var(--font-small-size)",
        fontWeight: "var(--font-small-label-weight)",
        lineHeight: "var(--font-small-line)",
      }}
    >
      <i className="pi pi-bolt" style={{ fontSize: "0.75rem" }} aria-hidden="true" />
      {label}
    </span>
  );
};
